export default "__VITE_ASSET__e1a1T9vu__"